exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ConnectGoogleButton__link__2TWlc{text-decoration:none}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/ConnectGoogleButton.scss"],"names":[],"mappings":"AAGA,kCACE,oBAAqB,CACtB","file":"ConnectGoogleButton.scss","sourcesContent":["@import '../../styles/mixins.scss';\n\n\n.link {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"link": "ConnectGoogleButton__link__2TWlc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/ConnectGoogleButton.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/ConnectGoogleButton.scss
// module chunks = 0